/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contentreportdeleted2Inputs */

const en_contentreportdeleted2 = /** @type {(inputs: Contentreportdeleted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report deleted`)
};

const de_contentreportdeleted2 = /** @type {(inputs: Contentreportdeleted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldung gelöscht`)
};

/**
* | output |
* | --- |
* | "Report deleted" |
*
* @param {Contentreportdeleted2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contentreportdeleted2 = /** @type {((inputs?: Contentreportdeleted2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contentreportdeleted2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contentreportdeleted2(inputs)
	return de_contentreportdeleted2(inputs)
});
export { contentreportdeleted2 as "contentReportDeleted" }